import * as types from '../constants/actionTypes';

// sagas
export const fetchDrivers = () => ({ type: types.FETCH_DRIVERS });

// messages
export const fetchDriversLoading = () => ({ type: types.FETCH_DRIVERS_LOADING });
export const fetchDriversError = () => ({ type: types.FETCH_DRIVERS_ERROR });
export const fetchDriversSuccess = data => ({
  type: types.FETCH_DRIVERS_SUCCESS,
  data,
});
